<template>
    <div>
        <b-row>
            <b-col cols="2 text-center">
                <slot name="logo">
                    <logo />
                </slot>
            </b-col>

            <b-col cols="10">
                <slot name="breadcrumbs" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="2 text-center">
                <slot name="back"></slot>
            </b-col>

            <b-col cols="10">
                <slot name="title"></slot>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="2 text-center">
                <slot name="nav"></slot>
            </b-col>

            <b-col cols="10">
                <slot name="main"></slot>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
    name: "basic-layout",
    data: function () {
        return {};
    },
    components: { Logo },
};
</script>

<style lang="scss">

</style>
